export default {
  VIEW: 'view',
  TOKEN: 'token',
};
